<script setup lang="ts">
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger } from "@/components/ui/select"
import CountryFlag from "vue-country-flag-next"
import { ref, computed, watch } from "vue"
import { changeLocale } from "@/lib/router_utils";

const selectedLanguage = ref(I18n.locale)

const flag = computed(() => {
  return selectedLanguage.value == 'en' ? 'gb' : 'it'
})

watch(selectedLanguage, newValue => {
  changeLocale(newValue)
})
</script>

<template>
  <Select v-model="selectedLanguage">
    <SelectTrigger class="my-2 ml-auto w-20 items-center bg-muted">
      <country-flag :country="flag" class="relative bottom-1" />
    </SelectTrigger>

    <SelectContent>
      <SelectGroup>
        <SelectLabel>{{ $t("commons.languages.placeholder") }}</SelectLabel>

        <SelectItem value="it"> {{ $t("commons.languages.it") }} </SelectItem>

        <SelectItem value="en"> {{ $t("commons.languages.en") }} </SelectItem>
      </SelectGroup>
    </SelectContent>
  </Select>
</template>